// Modules
import React, { ReactElement, useState } from 'react';

// Styled Components
import * as EVENT from './event-checkout.styles';

// Types
import { Event } from '../../types/events';

import ArrowSm from '../../assets/arrow-small.svg';


// Constants
const EventCheckout = ({ lang, dir, event }: { event: Event, lang: string, dir: string }): ReactElement => {
	const [hover, setHover] = useState(false);


	// Render
	return (
		<EVENT.Checkout
			onMouseLeave={() => setHover(false)}
			onMouseOver={() => setHover(true)}
			href={event.cta.url}
			target="_blank"
		>
			<EVENT.PBold>{event.cta.text}</EVENT.PBold>
			<EVENT.CheckoutIcon direction={dir} hover={hover} src={ArrowSm} alt=""/>
		</EVENT.Checkout>
	);
};

export default EventCheckout;
